import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import Tibbits from '@appblocks/codegeneration/Tibbits';

export default class Tibbit26SendNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Tibbit 26 Send';
        this.id = 'node_tibbit_26_send';
        this.linkedFeature = 'general';
        this.description = 'Send IR code';

        this.inputs = [
            {
                name: 'Send',
                portId: 'tbt26_play_back',
                params: [
                    {
                        name: 'data',
                        description: 'IR Command',
                        dataType: TibboDataType.STRING,
                        default: '',
                    },
                ],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit 26',
                settingType: SettingType.OPTION,
                refId: 'tibbit_26',
                required: true,
                default: '',
                options: [],
            },
            // {
            //     id: 'ENCODING',
            //     name: 'Encoding',
            //     settingType: SettingType.OPTION,
            //     required: true,
            //     default: '',
            //     options: [
            //         {
            //             name: 'None',
            //             value: '',
            //         },
            //         {
            //             name: 'NEC',
            //             value: 'nec',
            //         },
            //     ],
            // },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const TIBBIT = this.getSettingValue('TIBBIT');
        const tibbit = project.getFeature(TIBBIT);
        if (tibbit === undefined) {
            return blocks;
        }
        const tibbitName = tibbit.getSettingValue('NAME');
        // const ENCODING = this.getSettingValue('ENCODING');

        const links = project.getNodeLinks(this, 'tbt26_play_back');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    tbt26_play_back(${project.getNodeParameter(link, 'data')}, ${tibbitName}_CS, ${tibbitName}_channel)`,
            });
        }

        return blocks;
    }
}
